import { Typography, Grid } from "@mui/material";
import { format } from "date-fns";
import React from "react";
import { CustomerInterface } from "../../Objects/Customer";

export interface MemberPointProps {
    customerData: CustomerInterface
}

const MemberPoint: React.FC<MemberPointProps> = ({
    customerData
}) => {
    return (
        <>
            {customerData.point &&
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="caption" sx={{color: "#333399"}}>ポイント</Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">{customerData.point.toLocaleString()}ポイント</Typography>
                    </Grid>
                </Grid>
            }
        </>
    );
}

export default MemberPoint